export default __webpack_public_path__ + "static/media/woman-at-desk.c4d7b430.png";